import React, { useEffect, useState } from 'react';
import '../stylings/OrderConfirmation.css';

function OrderConfirmation({ orderData, onClose, emailSent = true }) {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Scroll to top when order confirmation loads
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    // Animation effect
    setTimeout(() => setIsVisible(true), 100);
    
    // Don't clear cart here - it's already handled in BucksCheckout
    // The cart clearing should happen once after successful payment, not in OrderConfirmation
  }, []); // Empty dependency array since we removed clearCart

  // Print order function
  const handlePrintOrder = () => {
    const printContent = document.getElementById('order-confirmation-content');
    const originalContent = document.body.innerHTML;
    
    // Create a clean print version
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Order Confirmation - ${orderData.orderNumber}</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              margin: 20px; 
              color: #333;
              line-height: 1.6;
            }
            .print-header { 
              text-align: center; 
              margin-bottom: 30px; 
              border-bottom: 2px solid #a67c52;
              padding-bottom: 20px;
            }
            .print-header h1 { 
              color: #6b4c35; 
              margin: 0;
              font-size: 2rem;
            }
            .print-header h2 { 
              color: #6b5a44; 
              margin: 5px 0 0 0;
              font-weight: normal;
            }
            .order-details { 
              margin: 20px 0; 
            }
            .detail-section { 
              margin: 15px 0; 
              padding: 15px;
              background-color: #faf7f0;
              border-radius: 8px;
            }
            .detail-section h3 { 
              color: #6b4c35; 
              margin: 0 0 10px 0;
              font-size: 1.1rem;
            }
            .pickup-info-print p {
              margin: 5px 0;
            }
            .items-list { 
              list-style: none; 
              padding: 0; 
              margin: 0;
            }
            .items-list li { 
              display: flex; 
              justify-content: space-between; 
              padding: 8px 0; 
              border-bottom: 1px solid #e5dbc5;
            }
            .items-list li:last-child { 
              border-bottom: none; 
            }
            .totals { 
              margin-top: 20px; 
              padding: 15px;
              background-color: #f5f0e5;
              border-radius: 8px;
            }
            .total-line { 
              display: flex; 
              justify-content: space-between; 
              padding: 5px 0; 
            }
            .total-line.grand-total { 
              font-weight: bold; 
              border-top: 1px solid #a67c52; 
              padding-top: 10px; 
              margin-top: 10px;
            }
            .print-footer { 
              margin-top: 30px; 
              text-align: center; 
              font-size: 0.9rem; 
              color: #6b5a44;
            }
            @media print {
              body { margin: 0; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          <div class="print-header">
            <h1>Buck's Farmstand</h1>
            <h2>Order Confirmation</h2>
          </div>
          
          <div class="order-details">
            <div class="detail-section">
              <h3>Order Information</h3>
              <p><strong>Order Number:</strong> ${orderData.orderNumber}</p>
              <p><strong>Customer:</strong> ${orderData.customerInfo.name}</p>
              <p><strong>Email:</strong> ${orderData.customerInfo.email}</p>
              <p><strong>Phone:</strong> ${orderData.customerInfo.phone}</p>
              <p><strong>Date:</strong> ${new Date(orderData.dateCreated).toLocaleDateString()}</p>
            </div>
            
            <div class="detail-section">
              <h3>${orderData.deliveryMethod === 'delivery' ? 'Delivery' : 'Pickup'} Information</h3>
              ${orderData.deliveryMethod === 'delivery' && orderData.customerInfo.address ? 
                `<p><strong>Delivery Address:</strong> ${orderData.customerInfo.address.line1}, ${orderData.customerInfo.address.city}, ${orderData.customerInfo.address.state} ${orderData.customerInfo.address.zipCode}</p>` :
                `<div class="pickup-info-print">
                   <p><strong>Pickup Location:</strong> Buck's Farmstand</p>
                   <p><strong>Address:</strong> 4250 W 123rd St, Alsip, IL 60803</p>
                   <p><strong>Required:</strong> Please bring valid ID and email receipt</p>
                 </div>`
              }
              <p><strong>Estimated ${orderData.deliveryMethod === 'delivery' ? 'delivery' : 'pickup'} time:</strong> ${orderData.deliveryMethod === 'delivery' ? 'Tomorrow, 9am-1pm' : 'Tomorrow by 1:00 PM'}</p>
            </div>
            
            <div class="detail-section">
              <h3>Order Items</h3>
              <ul class="items-list">
                ${orderData.items.map(item => `
                  <li>
                    <span>${item.quantity}× ${item.name}</span>
                    <span>$${(item.unitPrice * item.quantity).toFixed(2)}</span>
                  </li>
                `).join('')}
              </ul>
            </div>
            
            <div class="totals">
              <div class="total-line">
                <span>Subtotal</span>
                <span>$${orderData.subtotal.toFixed(2)}</span>
              </div>
              ${orderData.discount > 0 ? `
                <div class="total-line">
                  <span>Discount ${orderData.promoCode ? `(${orderData.promoCode})` : ''}</span>
                  <span>-$${orderData.discount.toFixed(2)}</span>
                </div>
              ` : ''}
              ${orderData.deliveryMethod === 'delivery' && orderData.deliveryFee !== undefined ? `
                <div class="total-line">
                  <span>Delivery</span>
                  <span>${orderData.deliveryFee === 0 ? 'Free' : `$${orderData.deliveryFee.toFixed(2)}`}</span>
                </div>
              ` : ''}
              <div class="total-line grand-total">
                <span>Total</span>
                <span>$${orderData.total.toFixed(2)}</span>
              </div>
            </div>
          </div>
          
          <div class="print-footer">
            <p>Thank you for supporting our small family farm!</p>
            <p>Buck's Farmstand • 4250 W 123rd St, Alsip, IL 60803 • (708) 555-0123</p>
          </div>
        </body>
      </html>
    `);
    
    printWindow.document.close();
    printWindow.focus();
    
    // Wait for content to load, then print
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  };

  // Export order as JSON
  const handleExportOrder = () => {
    const exportData = {
      orderNumber: orderData.orderNumber,
      orderDate: orderData.dateCreated,
      customer: {
        name: orderData.customerInfo.name,
        email: orderData.customerInfo.email,
        phone: orderData.customerInfo.phone
      },
      deliveryMethod: orderData.deliveryMethod,
      deliveryAddress: orderData.customerInfo.address,
      items: orderData.items,
      pricing: {
        subtotal: orderData.subtotal,
        discount: orderData.discount,
        promoCode: orderData.promoCode,
        deliveryFee: orderData.deliveryFee,
        total: orderData.total
      },
      specialInstructions: orderData.specialInstructions
    };

    const dataStr = JSON.stringify(exportData, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = `bucks-farmstand-order-${orderData.orderNumber}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  // If no order data is provided, show error message
  if (!orderData) {
    return (
      <div className={`order-confirmation-container ${isVisible ? 'visible' : ''}`}>
        <div className="order-confirmation error">
          <div className="confirmation-icon error">!</div>
          <h1>Order Information Missing</h1>
          <p>We couldn't find your order details. Please contact customer support.</p>
          <div className="confirmation-actions">
            <a href="/" className="home-btn">Return to Home</a>
            <a href="/shop" className="shop-btn">Continue Shopping</a>
          </div>
        </div>
      </div>
    );
  }

  const { 
    orderNumber, 
    customerInfo, 
    deliveryMethod, 
    items, 
    subtotal, 
    discount, 
    deliveryFee, 
    total,
    promoCode
  } = orderData;

  return (
    <div className={`order-confirmation-container ${isVisible ? 'visible' : ''}`}>
      <div className="order-confirmation" id="order-confirmation-content">
        <div className="confirmation-icon">✓</div>
        <h1>Thank You!</h1>
        <h2>Your order has been received</h2>
        
        <div className="confirmation-details">
          <p className="order-number">Order Number: <span>{orderNumber}</span></p>
          
          <div className="email-notification">
            <p className="email-status">
              {emailSent ? (
                <span>A confirmation email has been sent to <span className="email-highlight">{customerInfo.email}</span></span>
              ) : (
                <span>We couldn't send a confirmation email. Please contact us if you don't receive it shortly.</span>
              )}
            </p>
            {emailSent && (
              <div className="email-disclaimer">
                <span className="disclaimer-icon">📧</span>
                <p>
                  Don't see your confirmation email? Please check your spam or junk folder and mark our email as "not spam" 
                  to ensure you receive future updates about your order.
                </p>
              </div>
            )}
          </div>
          
          <div className="delivery-info">
            <h3>{deliveryMethod === 'delivery' ? 'Delivery' : 'Pickup'} Information</h3>
            {deliveryMethod === 'delivery' && customerInfo.address ? (
              <p>Your order will be delivered to {customerInfo.address.line1}, {customerInfo.address.city}, {customerInfo.address.state} {customerInfo.address.zipCode}</p>
            ) : (
              <>
                <p>Please pick up your order at Buck's Farmstand during operating hours.</p>
                <div className="pickup-instructions">
                  <p><strong>📍 Pickup Location:</strong> Buck's Farmstand</p>
                  <p><strong>📍 Address:</strong> 4250 W 123rd St, Alsip, IL 60803</p>
                  <p><strong>📄 Required:</strong> Please bring a valid ID and your email order receipt</p>
                  <p><strong>📞 Optional:</strong> Call ahead to confirm your order is ready</p>
                </div>
              </>
            )}
            <p className="estimated-time">Estimated {deliveryMethod === 'delivery' ? 'delivery' : 'pickup'} time: <span>{deliveryMethod === 'delivery' ? 'Tomorrow, 9am-1pm' : 'Tomorrow by 1:00 PM'}</span></p>
          </div>
          
          <div className="order-summary">
            <h3>Order Summary</h3>
            <ul className="confirmation-items">
              {items.map((item, index) => (
                <li key={index}>
                  <span className="item-quantity">{item.quantity}×</span>
                  <span className="item-name">{item.name}</span>
                  <span className="item-price">${(item.unitPrice * item.quantity).toFixed(2)}</span>
                </li>
              ))}
            </ul>
            
            <div className="confirmation-totals">
              <div className="total-line">
                <span>Subtotal</span>
                <span>${subtotal.toFixed(2)}</span>
              </div>
              
              {discount > 0 && (
                <div className="total-line discount">
                  <span>Discount {promoCode ? `(${promoCode})` : ''}</span>
                  <span>-${discount.toFixed(2)}</span>
                </div>
              )}
              
              {/* Only show delivery fee if delivery method is selected AND there's a delivery fee */}
              {deliveryMethod === 'delivery' && deliveryFee !== undefined && (
                <div className="total-line">
                  <span>Delivery</span>
                  <span>{deliveryFee === 0 ? 'Free' : `$${deliveryFee.toFixed(2)}`}</span>
                </div>
              )}
              
              <div className="total-line grand-total">
                <span>Total</span>
                <span>${total.toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Order Actions Section */}
        <div className="order-actions">
          <div className="order-utilities">
            <button className="utility-btn print-btn" onClick={handlePrintOrder}>
              <span className="utility-icon">🖨️</span>
              <span>Print Order</span>
            </button>
            <button className="utility-btn export-btn" onClick={handleExportOrder}>
              <span className="utility-icon">📄</span>
              <span>Export Order</span>
            </button>
          </div>
        </div>
        
        <div className="confirmation-actions">
          <a href="/" className="home-btn">Return to Home</a>
          <a href="/shop" className="shop-btn">Continue Shopping</a>
        </div>
        
        <div className="trust-message">
          <span className="trust-icon">🌱</span>
          <p>Thank you for supporting our small local farmstand. We're grateful for your business!</p>
        </div>
      </div>
    </div>
  );
}

export default OrderConfirmation;